// extracted by mini-css-extract-plugin
module.exports = {"spinner":"ScoreTiers-module__spinner___34bY-"};